module.exports = __webpack_public_path__ + "img/ls4.445c9236.png";